import styles from "./Landing.module.css";
import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import LoginIcon from "@mui/icons-material/Login";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";

const Landing = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/signin");
  };

  return (
    <div className="App">
      <AppBar
        position="absolute"
        sx={{
          color: "black",
          backgroundColor: "white",
          boxShadow: "0px 3px 40px #4343430A",
        }}
      >
        <Toolbar>
          <Typography component="h1" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
            KMK
          </Typography>
          <IconButton edge="start" color="inherit" aria-label="open drawer" onClick={handleLogin}>
            <LoginIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) => {
            return theme.palette.TiffanyBlue.main;
          },
          flexGrow: 1,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <header className={styles.appHeader}>
          <img src="/images/vortex.png" className={styles.appLogo} alt="logo" />
          <br />
          Welcome to Vortex Control Panel
        </header>
      </Box>
    </div>
  );
};

export default Landing;
